import { motion } from "framer-motion";

export const easeSmooth = [0.65, 0, 0.35, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true, ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 1.0, delay, ease: easeSmooth }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for a block of headline text.
export const RevealLines = ({ lines, className = "", delayBase = 0.05, stagger = 0.12 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay: delayBase + i * stagger, ease: easeSmooth }}
          style={{ display: "block", willChange: "transform" }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </div>
);

export const RevealWordsOnView = ({ text, className = "", stagger = 0.03 }) => {
  const words = text.split(" ");
  return (
    <p className={className}>
      {words.map((w, i) => (
        <span key={i} className="inline-block overflow-hidden align-bottom">
          <motion.span
            initial={{ y: "110%", opacity: 0 }}
            whileInView={{ y: "0%", opacity: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.85, delay: i * stagger, ease: easeSmooth }}
            className="inline-block"
          >
            {w}&nbsp;
          </motion.span>
        </span>
      ))}
    </p>
  );
};
